// Breadcrumbs for document and collection pages.

import type { Collection, Document } from '@airhead-games/shared/content';

export interface BreadcrumbItem {
  label: string;
  path: string;
}

export const getDocumentBreadcrumbs = (
  document: Document
): BreadcrumbItem[] => {
  if (document.kind === 'game') {
    return [
      { label: 'Discover', path: '/discover' },
      { label: 'Games', path: '/discover/games' },
      {
        label: document.seo.title.replace(/^Discover\s+/, ''),
        path: document.route,
      },
    ];
  }

  if (document.kind === 'feature') {
    return [
      { label: 'Discover', path: '/discover' },
      { label: 'Features', path: '/discover/features' },
      {
        label: document.seo.title.replace(/^Discover\s+/, ''),
        path: document.route,
      },
    ];
  }

  if (document.kind === 'blog') {
    return [
      { label: 'Blog', path: '/blog' },
      { label: document.seo.title, path: document.route },
    ];
  }

  if (document.kind === 'report') {
    return [
      { label: 'Party Central', path: '/party-central' },
      { label: 'Reports', path: '/party-central/reports' },
      { label: document.seo.title, path: document.route },
    ];
  }

  return [{ label: document.seo.title, path: document.route }];
};

export const getCollectionBreadcrumbs = (
  collection: Collection
): BreadcrumbItem[] => {
  if (collection.id === 'collection:discover') {
    return [{ label: 'Discover', path: collection.route }];
  }

  if (collection.id === 'collection:games') {
    return [
      { label: 'Discover', path: '/discover' },
      { label: 'Games', path: collection.route },
    ];
  }

  if (collection.id === 'collection:features') {
    return [
      { label: 'Discover', path: '/discover' },
      { label: 'Features', path: collection.route },
    ];
  }

  if (collection.id === 'collection:reports') {
    return [
      { label: 'Party Central', path: '/party-central' },
      { label: 'Reports', path: collection.route },
    ];
  }

  return [{ label: collection.title, path: collection.route }];
};
